module.exports = __webpack_public_path__ + "static/img/threePhase_good2.58550c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/goods/threePhase_good2.png
// module id = 5CUV
// module chunks = 1